import { useNavigate } from 'react-router-dom'
import { FullScreenDialog } from './FullScreenDialog'
import PerfImage from '../assets/login_perfs.png'
import Parfum from '../assets/parfum.png'
import { GoogleLoginButton } from '../components/login/GoogleLoginButton'
import { AppleLoginButton } from '../components/login/AppleLoginButton'
import { useAuth } from '../pocketbase/useAuth'
import { OkDialog } from '../components/dialogs/OkDialog'
import { useState } from 'react'

export const LoginDialog = () => {
  const navigate = useNavigate()
  const { loginViaGoogle, loginViaApple } = useAuth()
  const [errorDialogOpen, setErrorDialogOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const onGoogleClick = async () => {
    try {
      await loginViaGoogle()
      navigate('/dashboard')
    } catch (err: any) {
      console.error('Login failed:', err)
      setErrorMessage(err?.message || 'An unexpected error occurred during login.')
      setErrorDialogOpen(true)
    }
  }

  const onAppleClick = async () => {
    try {
      await loginViaApple()
      navigate('/dashboard')
    } catch (err: any) {
      console.error('Login failed:', err)
      setErrorMessage(err?.message || 'An unexpected error occurred during login.')
      setErrorDialogOpen(true)
    }
  }

  return (
    <FullScreenDialog isOpen={true} onClose={() => navigate(-1)}>
      <div className={'grid grid-cols-1 md:grid-cols-2 h-full overflow-hidden'}>
        <div className={'flex items-center justify-center'}>
          <div className={'flex flex-col items-center w-2/3 space-y-4'}>
            <img src={Parfum} className={'md:hidden w-[80px]'} />
            <div className={'text-4xl font-semibold'}>Welcome back!</div>
            <div className={'text-xl text-center pb-6'}>
              Log in to rediscover your signature scents, browse reviews and
              share your own scent stories.
            </div>
            <GoogleLoginButton onClick={onGoogleClick} />
            <AppleLoginButton onClick={onAppleClick} />
          </div>
        </div>

        <div
          className={'hidden md:block bg-background bg-cover bg-center w-full h-full'}
          style={{ backgroundImage: `url(${PerfImage})` }}
        ></div>
      </div>
      <OkDialog
        isOpen={errorDialogOpen}
        onClose={() => setErrorDialogOpen(false)}
        title="Login Failed"
        content={errorMessage}
      />
    </FullScreenDialog>
  )
}
